class AppMain {
    
    static main(_, $, $state, $rootScope, helperService, securityService, componentRegistryService, componentDataService, initConfigProvider, menu) {

        componentRegistryService.setOnRegister(componentDataService.setModel.bind(componentDataService));
        componentRegistryService.setOnDeRegister(componentDataService.updateModel.bind(componentDataService));

        $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams) {

            //clear component registry on state change
            componentRegistryService.reset();

            securityService.isAuthenticated().then((result) => {
                var authResult = result;
                // if NOT on the auth page...
                if (toState.name.indexOf("auth.login") === -1) {
                    // if not already authenticated...
                    if (toState.name.indexOf("/.") > -1 && !authResult) {
                        // stop state change
                        event.preventDefault();
                        //Note: we don't call logout here anymore because it'll logout SSO session as well
                        //Logout is now called in the SSO controller if it fails to authenticate
                        //securityService.logout();
                        
                        //always redirect to sso page for OpenAm Cloud
                        $state.go("auth.sso");
                        /*if (securityService.hasSSOCookie()) {
                            $state.go("auth.sso");
                        } else {
                            $state.go("auth.login");
                        }*/
                    }
                    
                    // redirect if abstarct state requested
                    if (_.filter($rootScope.abstractStates, function(s) { return toState.name === s.name }).length > 0) {
                        event.preventDefault();
                        $state.go("/.coi.home");
                    }
                    
                    // check user has correct role to view page.
                    if (toState.name.indexOf("error.403") === -1 && authResult && !helperService.hasValidRoleForAction(securityService.getAutheticatedUserRoles(), helperService.getMenuByState(menu, toState.name))) {
                            event.preventDefault();
                            $state.go("error.403");                        
                    }
                }
            });            
        });

        $rootScope.$on('$locationChangeSuccess', (event, newUrl) => {
            securityService.isAuthenticated().then((result) => {
                if (!$rootScope.returnUrl && !result) {
                    let relativeUrl = _.replace(newUrl, `${initConfigProvider.serverBaseUrl}/coi`, '');
                    $rootScope.returnUrl = relativeUrl;
                }
            });            
        });

        $rootScope.$on('$viewContentLoaded', () => {
            // Always scroll to top of page on view change.
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        });
        
        $rootScope.abstractStates = _.filter($state.get(), function(s) { return s.abstrct === true });
        
        $rootScope.urlMatcherForStates = helperService.createUrlMatcherForStates($state);

        $rootScope.$on('$includeContentLoaded', () => {
            //reload bilya scripts after content load.
            // this is a nasty, nasty hack required to properly parse menus etc that
            // aren't on the page before angular loads
            $('script[src*="bilya"][src$="scripts.min.js"]').each(function(index, script) {
                script.remove();
                $(script).appendTo('head');
            });
        });
    }
}

AppMain.main.$inject = ['_', '$', '$state', '$rootScope', 'helperService', 'securityService','componentRegistryService', 'componentDataService', 'initConfigProvider', 'menuProvider'];

export default AppMain;



// WEBPACK FOOTER //
// ./app/app.main.js